import React, { useMemo } from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { graphql, useStaticQuery } from 'gatsby';
import { SectionHeader } from '../ui/SectionHeader';

export const TestimonialsSection = () => {
  const { nomadago, images } = useStaticQuery(graphql`
    query testimonialsSection {
      images: allFile(
        filter: { relativeDirectory: { eq: "homepage/testimonials" } }
      ) {
        edges {
          node {
            name
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
    }
  `);

  const testimonials = useMemo(() => {
    const testimonialImages = images.edges.reduce((acc: any, { node }: any) => {
      acc[node.name] = node.childImageSharp.gatsbyImageData;

      return acc;
    }, {});

    return [
      {
        name: 'Sam S.',
        jobTitle: 'Facilitator @ Hacker Paradise',
        image: testimonialImages.sam,
        quote:
          'Nomadago makes it super easy to see which of my friends will be at one of my HP [community] locations. It also makes it super easy to share my travel plans with parents and friends back home.',
      },
      {
        name: 'Molly V.',
        jobTitle: 'Marketing Manager',
        image: testimonialImages.molly,
        quote:
          'To say that Nomadago is a game changer would be an understatement. It connected me with a roommate in South Africa, alerted me to an overlapping trip with an acquaintance in Korea who, after that trip, is now a good friend, and effortlessly gathered 11 people for my travel plans in Georgia - This app has simplified and significantly enhanced my nomadic lifestyle by reconnecting me with friends around the world.',
      },
      {
        name: 'Connor M.',
        jobTitle: 'Wandering Wellness Wizard',
        image: testimonialImages.connor,
        quote:
          "Using Nomadago has really helped me link up with friends that are always on the move. By utilizing Nomadago's map and calendar features I am able to plan around my friends’ travel schedules. I can efficiently plan trips around where they may be in the world.",
      },
    ];
  }, [nomadago]);

  return (
    <section className="relative py-8 bg-blue-500 md:mx-3 lg:py-16 md:rounded-2xl">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 1440 395"
        className="absolute left-0 w-full text-blue-200 top-1/4"
      >
        <path
          stroke="currentColor"
          strokeDasharray="16 16"
          strokeLinecap="round"
          strokeWidth="4"
          d="M-85 232C0 90 155.86 3.43 217 56c414 356 318-75.39 552 18.61S1112 38 1112 38s241-142 271 156c3.67 64.46 5.2 196.6 126 199"
          opacity=".5"
        />
        <circle cx="729.5" cy="62.5" r="6.5" fill="#fff" />
        <circle cx="180.5" cy="40.5" r="6.5" fill="#fff" />
        <circle cx="1384.5" cy="207.5" r="6.5" fill="#fff" />
      </svg>

      <SectionHeader
        heading="Hear From Our Community"
        subheading="Our users are at the heart of everything we do. See what they have to say about their experiences with Nomadago"
        className="container text-white"
        headingClassName="text-white"
      />

      <div className="container relative">
        <div className="-mx-4 overflow-auto">
          <ul className="px-4 grid grid-cols-3 w-[250%] md:w-[180%] lg:items-start list-none lg:w-auto gap-4 py-6 mt-6">
            {testimonials.map(person => (
              <li
                key={person.name}
                className="flex flex-col w-full gap-6 p-8 overflow-hidden bg-white rounded-lg shadow-md"
              >
                <p>{person.quote}</p>

                <div className="flex items-center gap-4 mt-auto">
                  <GatsbyImage
                    className="w-16 h-16 rounded-full"
                    image={person.image}
                    alt={person.name}
                  />

                  <div>
                    <p className="text-lg font-semibold text-blue-500">
                      {person.name}
                    </p>
                    <p className="text-sm text-blue-400">{person.jobTitle}</p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
